import {useMemo} from 'react';

import {Icon, IconName, IconSize, Tooltip} from 'components';
import {CreditCardType} from 'enums';

type Props = {
    name: string;
    iconSize?: IconSize;
    className?: string;
};

export const CreditCardIcon: React.FC<Props> = ({name, className, iconSize = '3xl'}) => {
    const iconName: IconName = useMemo(() => {
        if (name === CreditCardType.Visa) {
            return 'visa';
        } else if (name === CreditCardType.MasterCard) {
            return 'mastercard';
        } else if (name === CreditCardType.AmericanExpress) {
            return 'american-express';
        } else if (name === CreditCardType.Discover) {
            return 'discover';
        } else if (name === CreditCardType.Jcb) {
            return 'jcb';
        } else {
            return 'credit-card';
        }
    }, [name]);

    return (
        <Tooltip message={name} disabled={!name}>
            <Icon className={className} size={iconSize} name={iconName} />
        </Tooltip>
    );
};
